import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { GlobalThisABTestClient } from "../../domain/globalThisABTestClient/GlobalThisABTestClient";
import { queryClientContext } from "../hooks/useQueryClient";
import { useStaticInfo } from "../hooks/useStaticInfo";

const globalThisABTestClient = new GlobalThisABTestClient();

const useMoreProductsPerCategory = () => {
  const {
    session: { auth },
  } = useStaticInfo();

  const queryClient = useContext(queryClientContext);

  const { data } = useQuery(
    {
      queryKey: ["useMoreProductsPerCategory"],
      queryFn: async () => {
        const experiments = await globalThisABTestClient.getExperiments();

        return experiments ? experiments.moreProductsPerCategory : false;
      },
      enabled: Boolean(auth),
    },
    queryClient,
  );

  return data;
};

export { useMoreProductsPerCategory };
